import { useState, useCallback } from "react";
import { OnboardingChip } from "./OnboardingChip";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Video01Icon,
  TextAlignLeft01Icon,
  PromotionIcon,
  Crown03Icon,
  City02Icon,
  User03Icon,
  BookOpen01Icon,
  DiscoverSquareIcon,
} from "@hugeicons/core-free-icons";

const ROLE_OPTIONS = [
  { id: "creator", label: "Creator", icon: Video01Icon },
  { id: "content_team", label: "Content team", icon: TextAlignLeft01Icon },
  { id: "marketer", label: "Marketer", icon: PromotionIcon },
  { id: "founder", label: "Founder", icon: Crown03Icon },
  { id: "agency", label: "Agency", icon: City02Icon },
  { id: "freelancer", label: "Freelancer", icon: User03Icon },
  { id: "educator", label: "Educator", icon: BookOpen01Icon },
  { id: "other", label: "Other", icon: DiscoverSquareIcon },
] as const;

interface RoleStepProps {
  value: string | null;
  onChange: (value: string) => void;
}

export function RoleStep({ value, onChange }: RoleStepProps) {
  const [selecting, setSelecting] = useState<string | null>(null);

  const handleSelect = useCallback(
    (id: string) => {
      if (selecting) return;
      setSelecting(id);
      setTimeout(() => onChange(id), 600);
    },
    [selecting, onChange],
  );

  const active = selecting ?? value;

  return (
    <div>
      <h1 className="font-display text-3xl font-normal text-foreground">
        Which one describes you best?
      </h1>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {ROLE_OPTIONS.map((option) => (
          <OnboardingChip
            key={option.id}
            icon={<HugeiconsIcon icon={option.icon} className="size-5" />}
            label={option.label}
            selected={active === option.id}
            dismissing={selecting !== null}
            onClick={() => handleSelect(option.id)}
          />
        ))}
      </div>
    </div>
  );
}
